import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import checkCircularImage from "../../assets/check_circular.png";
import Layout from "../../components/layout/Layout";
import "./InviteSentPage.css";
import { ClientContext } from "../../state/ClientContext";

const InviteSentPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { changeSelectedCaregiver } = useContext(ClientContext);

  useEffect(() => {
    if (isLoaded) {
      return;
    }

    if (location.state && location.state.user) {
      setIsLoaded(true);
    }
  }, [isLoaded]);

  return !isLoaded ? null : (
    <Layout showSideNav={false}>
      <div style={{ width: "50%", margin: "auto" }}>
        <img
          src={checkCircularImage}
          // Decorative: the heading carries the status. Its old alt text
          // announced "Invite Sent" even when the email had failed.
          alt=""
          aria-hidden="true"
          style={{ width: "150px", height: "150px" }}
        />
        {location.state.emailWarning ? (
          // #771: the caregiver row exists but SES refused the email. Saying
          // "we sent an email" here left admins waiting on an invite that
          // never left.
          <>
            <h1 style={{ fontSize: "2rem" }}>Caregiver added</h1>
            <p role="alert" style={{ fontSize: "1.2rem" }}>
              They’ve been added to your caregiver list, but we couldn’t send
              the invitation email. Open the caregiver and use Resend Invite to
              try again.
            </p>
          </>
        ) : (
          <>
            <h1 style={{ fontSize: "2rem" }}>Invite Sent!</h1>
            <p style={{ fontSize: "1.2rem" }}>
              We sent an email to the caregiver inviting them to register their
              account, and they’ve been added to your caregiver list. After they
              register, you can assign them to clients.
            </p>
          </>
        )}
        <button
          className="btn-primary"
          style={{
            color: "#000",
            backgroundColor: "#66A77B",
            padding: "10px 20px",
            fontSize: "1.2rem",
          }}
          onClick={(ev) => {
            ev.preventDefault();
            changeSelectedCaregiver(location.state.user.id);
            navigate(`/caregiver_profile/${location.state.user.id}`, {
              state: { user: location.state.user },
            });
          }}
        >
          Go to caregiver
        </button>
      </div>
    </Layout>
  );
};

export default InviteSentPage;
